import siteDefaultIcon from "../../../icons/site-default.svg";
import { ApiUrlBuilder } from "../constants/apiUrl";

export abstract class SiteWithPhotoModel {
  protected constructor(public id: string) {}

  getPhotoUri(organizationCode: string) {
    return ApiUrlBuilder.getSitePhoto(organizationCode, this.id);
  }

  getDefaultPhotoUri(): string {
    return siteDefaultIcon;
  }
}
